module.exports = __webpack_public_path__ + "img/help-feature-menu.ec19956e.png";